/**
 * Auth server
 * Auth server API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CheckLivenessStatus {
    SUCCEED = 'SUCCEED',
    FAILED_LIVENESS = 'FAILED_LIVENESS',
    FAILED_FACE_NOT_MATCHED = 'FAILED_FACE_NOT_MATCHED',
    LIMIT_PER_SESSION_EXCEEDED = 'LIMIT_PER_SESSION_EXCEEDED'
}

